import { type AclPartnerUserConsentDTO, partnerApi } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

export const usePartnerConsentUserConsentByUserConsentQuery = () => {
	return useMutation({
		mutationFn: async ({ data = {}, userConsent }: { data: AclPartnerUserConsentDTO; userConsent: string }) =>
			(await partnerApi).putAclPartnerConsentUserConsentByUserConsent(userConsent, data),
		mutationKey: ['partnerUpdateUserConsent']
	});
};
